import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Tailwind CSS 클래스 병합을 위한 유틸리티 함수
 * clsx와 tailwind-merge를 조합하여 클래스명 충돌 방지
 */ export var cn = function() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return twMerge(clsx(inputs));
};
